import { FC, useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

import { Button, media } from '@/shared/components';
import { useIsDesktop } from '@/shared/hooks/use-is-desktop';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { NotRegisteredParticipantsModalProps } from '@/widgets/modals/types';

import { ModalContainerV2 } from '../containers/ModalContainerV2';

export const NotRegisteredParticipantsModal: FC<NotRegisteredParticipantsModalProps> = ({
  witnesses,
  executors,
}) => {
  const { t } = useTranslation('widgets/modals', {
    keyPrefix: 'notRegisteredParticipants',
  });
  const isDesktop = useIsDesktop();
  const modals = useModalsStore();
  const [executor, subExecutor] = executors;

  const handleSubmit = () => {
    // TODO: show the modal when notifications feature is implemented
    // modals.openModal({
    //   type: 'RemindersSentModal',
    // });
    modals.closeModal();
  };

  const unregisteredWitnesses = useMemo(
    () => witnesses.filter((witness) => witness.unregistered),
    [witnesses],
  );

  return (
    <ModalContainerV2 title={t('title')} pinBottom={true}>
      <DescriptionWrapper>
        <p>{t('description')}</p>
        <List>
          {unregisteredWitnesses?.map((witness, index) => (
            <li key={index}>
              {t('witness')} ({witness.name})
            </li>
          ))}
          {executor?.unregistered && (
            <li>
              {t('executor')} ({executor.name})
            </li>
          )}
          {subExecutor?.unregistered && (
            <li>
              {t('substituteExecutor')} ({subExecutor.name}))
            </li>
          )}
        </List>
      </DescriptionWrapper>
      <ButtonWrapper>
        <Button text={t('confirmButton')} isBlock={!isDesktop} onClick={handleSubmit} />
      </ButtonWrapper>
    </ModalContainerV2>
  );
};

const DescriptionWrapper = styled.div`
  padding: 24px 0px;
  white-space: pre-line;
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${media.mobile} {
    padding: 16px 0px 10px;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
`;

const List = styled.ul`
  padding-left: 24px;
`;
